module.exports = __webpack_public_path__ + "assets/img/2.ae616ac2.png";